$(document).ready(function(){

  var comfyText = (function(){
    var tag = document.querySelectorAll('textarea')
    for (var i=0; i<tag.length; i++){
      tag[i].addEventListener('paste',autoExpand)
      tag[i].addEventListener('input',autoExpand)
      tag[i].addEventListener('keyup',autoExpand)
    }
    function autoExpand(e,el){
      var el = el || e.target
      el.style.height = 'inherit'
      el.style.height = el.scrollHeight+'px'
    }
    window.addEventListener('load',expandAll)
    window.addEventListener('resize',expandAll)
    function expandAll(e){
      var tag = document.querySelectorAll('textarea')
      for (var i=0; i<tag.length; i++){
        autoExpand(e,tag[i])
      }
    }
  })()

  $('#phone').on("blur",function(){
    var value = $(this).val();
    if(value != ""){
      var phoneReplaces = value.replace(/ |,|-|_/g, '');
      var regexPhone = /^\d{10}$/;

      if(!regexPhone.test(phoneReplaces)){
        document.getElementById('warn-phone').innerHTML = "Le numéro indiqué n'est pas valide."
      }else{
        document.getElementById('warn-phone').innerHTML = ""
        var phone = phoneReplaces.replace(/(\w{2})/g, '$1 ').replace(/(^\s+|\s+$)/,'');
        $(this).val(phone)
      }

    }
  })

  $('input').on("focus",function(e){
    var value = $(this).val();
    if(value == ''){
      $(this).next()[0].innerHTML = ""
    }
  })

  // TYPE DE BIEN

  $("#flat, #house, #ground").on('click',function(e){
    document.getElementById('warn-loc').innerHTML = ""

    if(e.target.id == "flat"){
      $(this).toggleClass('selected')
      $("#house, #ground").removeClass('selected')
    }else if(e.target.id == "house"){
      $(this).toggleClass('selected')
      $("#flat, #ground").removeClass('selected')
    }else if(e.target.id == "ground"){
      $(this).toggleClass('selected')
      $("#flat, #house").removeClass('selected')
    }
  })


  $("#send").on('click',function(){
    var name =  document.getElementById('name').value;
    var phone =  document.getElementById('phone').value;
    var email = document.getElementById('email').value;
    var message =  document.getElementById('message').value;
    var ville =  document.getElementById('ville').value;
    var hab =  document.getElementById('hab').value;
    var terrain =  document.getElementById('terrain').value;
    var room =  document.getElementById('room').value;

    var regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if(name == ''){
      document.getElementById('warn-name').innerHTML = "Veuillez indiquer votre nom et prénom."
    }else{
      document.getElementById('warn-name').innerHTML = ""
    }

    var phoneReplaces = phone.replace(/ |,|-|_/g, '');
    var regexPhone = /^\d{10}$/;

    if(!regexPhone.test(phoneReplaces)){
      document.getElementById('warn-phone').innerHTML = "Le numéro indiqué n'est pas valide."
    }else{
      document.getElementById('warn-phone').innerHTML = ""
    }

    if(!regexEmail.test(email)){
      document.getElementById('warn-email').innerHTML = "L'email indiqué n'est pas valide."
    }else{
      document.getElementById('warn-email').innerHTML = ""
    }

    if(!$("#flat").hasClass('selected') &&
      !$("#house").hasClass('selected') &&
      !$("#ground").hasClass('selected')
    ){
      document.getElementById('warn-type').innerHTML = "Veuillez indiquer le type de bien que vous voulez faire estimer."
    }else{
      document.getElementById('warn-type').innerHTML = ""
    }

    if(ville == ''){
      document.getElementById('warn-loc').innerHTML = "Veuillez indiquer la ville dans laquel se trouve votre bien."
    }else{
      document.getElementById('warn-loc').innerHTML = ""
    }

    if(hab == ''){
      document.getElementById('warn-hab').innerHTML = "Veuillez indiquer la surface habitable de votre bien."
    }else{
      document.getElementById('warn-hab').innerHTML = ""
    }

    if(terrain == ''){
      document.getElementById('warn-terrain').innerHTML = "Veuillez indiquer la surface du terrain de votre bien."
    }else{
      document.getElementById('warn-terrain').innerHTML = ""
    }

    if(room == ''){
      document.getElementById('warn-room').innerHTML = "Veuillez indiquer le nombre de chambre de votre bien."
    }else{
      document.getElementById('warn-room').innerHTML = ""
    }


    if(name == '' || !regexPhone.test(phoneReplaces) || !regexEmail.test(email) ||
      ville == '' || hab == '' || terrain == '' || room == ''
    ){
      return false;
    }else{
      var obj = {}
      obj.name = name;
      obj.email = email;
      obj.phone = phone;
      obj.message = message;
      obj.ville = ville;
      obj.hab = hab;
      obj.terrain = terrain;
      obj.room = room;

      if($("#flat").hasClass('selected')){
        obj.bien = "Appartement";
      }else if($("#house").hasClass('selected')){
        obj.bien = "Maison";
      }else if($("#ground").hasClass('selected')){
        obj.bien = "Terrain";
      }


      $.ajax({
        type: "POST",
        url: 'https://api.agenceduchateau.bakasable.fr/estimation',
        data: obj,
        success: function(res){
          if(res.message == 'Demande envoyé'){
            $('#info').text('Message envoyé')
            $('#info').css({display : "block"})
            setTimeout(function(){
              $('#info').text('')
              $('#info').css({display : "none"})
            },4000)
          }
        },
        error: function() { alert('Erreur envoie email'); }
      });

    }

  })

});



// WEBPACK FOOTER //
// ./src/js/estimation.js